<template lang="pug">
  .tab-container.width-100.row(v-if='!isEmptyObject(resource)')
    sidebar-index(
      :author='resource.author'
      :resourceTitle='resource.title'
      :resourceWebinar='resource.presentation.hasWebinar'
      :classes='resource.teacherMaterial.classPlans.length'
    )
    .content.item-1
      button.circle-button(type="button" @click='goToStart' :class='{ "show-button": showButton }')
        simple-svg.dark-gray-hover-blue(:filepath='DobleChevronIcon' :width='"20px"' :height='"20px"')
      router-view
</template>

<script>
import { mapState } from 'vuex'
import MarkdownIt from 'markdown-it'
import amplitude from 'amplitude-js'
import SidebarIndex from './SidebarIndex'
import Class from './Class'
import DobleChevronIcon from '../../assets/ic_doble-chevron.svg'
import downloadIcon from '../../assets/ic_download.svg'
import { openExternalLink } from '../../utils/behavior.js'
import { isEmptyObject } from '../../utils/object'
import { routes } from '../../router'

export default {
  components: { SidebarIndex, Class },
  data() {
    return {
      DobleChevronIcon,
      showButton: false,
      downloadIcon,
      md: new MarkdownIt({ html: true }),
      isEmptyObject
    }
  },
  watch: {
    resource(nextResource, prevResource) {
      if ((!prevResource.id || prevResource.id !== nextResource.id) && nextResource.id) {
        amplitude.getInstance().logEvent('Resource Teacher Tab', {
          id: nextResource.id,
          name: nextResource.title,
          educationalProgram: nextResource.educationalProgram.name,
          category: nextResource.category.name
        })
      }
    }
  },
  computed: {
    ...mapState({
      resource: state => state.resource.resource
    }),
    hasTrigger() {
      return (
        this.resource.teacherMaterial.classPlanDescription ||
        this.resource.teacherMaterial.pedagogicalGoal ||
        this.resource.teacherMaterial.hasMedia ||
        (this.resource.teacherMaterial.classPlans &&
        this.resource.teacherMaterial.classPlans.length > 1)
      )
    }
  },
  mounted() {
    openExternalLink()
    window.addEventListener('scroll', this.handleScroll)
    if (!this.hasTrigger) this.$router.push({ name: routes.teacherResourceClass, params: { classId: 1 } })
  },
  methods: {
    mdRender(state, field) {
      return state && state[field] ? this.md.render(state[field]) : null
    },
    goToStart() {
      window.scrollTo(0, 0)
    },
    handleScroll() {
      const { scrollY } = window
      this.showButton = scrollY >= 100
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';
@import '../../scss/variables/sizes';
@import '../../scss/common/texts';
@import '../../scss/common/markdown';

.content {
  margin-left: 50px;
  width: 100%;
}

.circle-button {
  align-items: center;
  background-color: $white;
  border: 1px solid $light-gray;
  border-radius: 50%;
  box-shadow: 0 2px 6px 0 $shadow-gray;
  display: flex;
  height: 50px;
  justify-content: center;
  opacity: 0;
  position: fixed;
  right: 10%;
  top: 80%;
  transition: opacity 0.5s;
  width: 50px;
}
</style>
